import { getModeledReigns as getStoreItems } from 'selectors'
import { useSelector } from 'react-redux'
import { reigns as rawFixtures } from '@fedsim/imports'

import { mapImported, modelDefaultValues } from '../helpers'

import Form from './form'

export function useReigns () {
  const rawImported: any[] = useSelector(getStoreItems)
  const imported = rawImported.map(model => modelDefaultValues(Form, model))
  const fixtures = rawFixtures.map(model => modelDefaultValues(Form, model))
  const mapped = mapImported(fixtures, imported)
  const notImported = mapped.filter(item => item.imported === false)

  return { mapped, fixtures, imported, notImported }
}
